import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DriversPage from "./pages/DriversPage";
import RidesPage from "./pages/RidesPage";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import MapPage from "./pages/MapPage";
import TrackingPage from "./pages/TrackingPage";
import HeatmapPage from "./pages/HeatmapPage";
import RevenuePage from "./pages/RevenuePage";
import SupportPage from "./pages/SupportPage";
import TarifsPage from "./pages/TarifsPage";
import NotificationsPage from "./pages/NotificationsPage";
import CommissionPage from "./pages/CommissionPage";
import UsersPage from "./pages/UsersPage";
import TarifsRegionsPage from "./pages/TarifsRegionsPage";
import TripsPage from "./pages/TripsPage";
import PickupPointsPage from "./pages/PickupPointsPage";


function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* APP PROTÉGÉE */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>

                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/drivers"
                  element={
                    <ProtectedRoute>
                      <DriversPage />
                    </ProtectedRoute>
                  }
                />
                 <Route
                      path="/rides"
                      element={
                        <ProtectedRoute>
                           <RidesPage />
                        </ProtectedRoute>
                      }
                  />
                  <Route
                    path="/map"
                    element={
                     <ProtectedRoute>
                       <MapPage />
                     </ProtectedRoute>
                    }
                  />

                  <Route
                     path="/tracking"
                     element={
                       <ProtectedRoute>
                          <TrackingPage />
                       </ProtectedRoute>
                    }
                 />

                 <Route
                    path="/heatmap"
                    element={
                     <ProtectedRoute>
                        <HeatmapPage />
                     </ProtectedRoute>
                    }
                 />

                 <Route
                    path="/revenue"
                    element={
                      <ProtectedRoute>
                         <RevenuePage />
                      </ProtectedRoute>
                    }
                 />

                 <Route
                    path="/support"
                    element={
                      <ProtectedRoute>
                         <SupportPage />
                      </ProtectedRoute>
                    }
                 />
                 <Route path="/tarifs" element={<ProtectedRoute><TarifsPage /></ProtectedRoute>} />
          
                 <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
                 <Route path="/commission" element={<ProtectedRoute><CommissionPage/></ProtectedRoute>} />
                 <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
                 <Route path="/tarifs-regions" element={<ProtectedRoute><TarifsRegionsPage /></ProtectedRoute>} />
                 <Route path="/trips" element={<ProtectedRoute><TripsPage /></ProtectedRoute>} />
                 <Route path="/pickup-points" element={<ProtectedRoute><PickupPointsPage /></ProtectedRoute>} />
              
              
              </Routes>
            </Layout>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
